/**
 * @author silence
 * @desc:首页，基础信息的借口
 * */

import request from '@/utils/ajax';

// 这个要补上 todo
export function queryConfig(data) {
	return request({
	  url: '/frontApi/getColumnModuleInfo',
		method: 'post',
		data,
	});
}

export function getCommenConfig(data) {
	return request({
	  url: '/frontApi/getColumnModuleInfo',
		method: 'post',
		data,
	});
}

export function getModuleShowInfos(data) {
	return request({
	  url: '/web/front/getModuleShowInfo',
	  method: 'get',
		params: data,
	});
}

export function getHeaderData() {
  return request({
	  url: '/web/front/getColumnShowInfo',
		method: 'post',
	});
}

export function getModuleContent(data) {
	return request({
	  url: '/web/front/getModuleContent',
		method: 'get',
		params: data,
	});
}

export function getModuleContentList(data) {
	return request({
	  url: '/web/front/getModuleContentList',
		method: 'get',
		params: data,
	});
}

export function getContentByContentId(data) {
	return request({
	  url: '/web/front/getContentByContentId',
		method: 'get',
		params: data,
	});
}

export function getContentTypeTree(data) {
	return request({
	  url: '/web/front/getContentTypeTree',
		method: 'get',
		params: data,
	});
}

export function getContentListByContentType(data) {
	return request({
	  url: '/web/front/getContentListByContentType',
		method: 'get',
		params: data,
	});
}

export function getContentTypeTreeContainContent(data) {
	return request({
	  url: '/web/front/getContentTypeTreeContainContent',
		method: 'get',
		params: data,
	});
}

export function getContentContainChildrenList(data) {
	return request({
	  url: '/web/front/getContentContainChildrenList',
		method: 'get',
		params: data,
	});
}


export function getFxCurrencyPairs(data) {
	return request({
	  url: '/crm/fp/getFxCurrencyPairs',
		method: 'get',
		params: data,
	});
}

export function getFxCalculator(data) {
	return request({
	  url: '/crm/fp/fxCalculator',
		method: 'get',
		params: data,
	});
}

export function getCurrencyChange(data) {
	return request({
	  url: '/crm/fp/currencyChange',
		method: 'get',
		params: data,
	});
}


export function getDictListByType(data) {
	return request({
	  	url: '/crm/fp/getDictListByType',
		method: 'get',
		params: data,
	});
}

export function getDictLabelByTypeAndValue(data) {
	return request({
	  	url: '/crm/fp/getDictLabelByTypeAndValue',
		method: 'get',
		params: data,
	});
}

export function partnerApply(data) {
	return request({
	  	url: '/crm/reception/partner/apply',
		method: 'get',
		params: data,
	});
}








/**
 * @author silence
 * @desc:头部json数据
 * */
export function getHeaderContent() {
	return request({
	  url: '/web/front/getSiteHeaderContent',
		method: 'post',
	});
}
/**
 * @author silence
 * @desc:尾部json数据
 * */
export function getFooterContent() {
	return request({
	  url: '/web/front/getSiteFooterContent',
		method: 'post',
	});
}

export function priceHis(params) {
	return request({
		url: '/crm/reception/tools/priceHis',
		method: 'get',
		params: params,
	});
}

export function tickHis(params) {
	return request({
		url: '/crm/reception/tools/tickHis',
		method: 'get',
		params: params,
	});
}

export function getHandshakeUrl(params) {
	return request({
		url: '/crm/reception/getHandshakeUrl',
		method: 'get',
		params: params,
	});
}

export function reportdownload(params) {
	return request({
		url: '/crm/reception/tradingcentral/reportdownload',
		method: 'get',
		params: params,
	});
}

export function selfreport(params) {
	return request({
		url: '/crm/fp/tradingcentral/selfreport',
		method: 'get',
		params: params,
	});
}


